import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import contact from '@/pages/help_center/contact_us/contact_us.module.scss'

import { NavLink } from '@/components/atoms/NavLink/NavLink'
import { Footer } from '@/components/organisms/Footer/Footer'

export default function index () {
  return (
    <>
      <Menu />
      <div className={contact.container}>
        <div className={contact.row}>
          <div className={contact.image_with_title_container}>
            <div className={contact.image_container}>
              <p className={contact.title}>Nuestros expertos te están esperando</p>
            </div>
            <div className={contact.title_container}>
              <h2 className={contact.title1}>Escríbenos, resolveremos tus dudas</h2>
              <form style={{ textAlign: 'center' }}>
                <input className={contact.input1} type='text' placeholder='Nombre' />
                <input className={contact.input1} type='tel' placeholder='Teléfono' />
                <input className={contact.input1} type='email' placeholder='Email' />
                <textarea className={contact.txtarea} rows='4' cols='50' placeholder='Escribe aquí' />
                <div className={contact.borde}>
                  <NavLink href='#' type='submit' name='Enviar' className={contact.button1} />
                </div>
              </form>
            </div>

          </div>
        </div>
        <div className={contact.row}>
          <div className={contact.card_container}>
            <div className={contact.card_column}>
              <div className={contact.card}>
                <div className={contact.icon_container}>
                  <NavLink href='#' type='submit' name='Chatear AHORA' className={contact.button2} />
                  <p className={contact.title2}>Chatea con nosotros</p>
                  <p className={contact.title3}>contacto@softbasys.com</p>

                </div>
              </div>
              <div className={contact.heimarg} />
            </div>
            <div className={contact.card_column}>
              <div className={contact.card}>
                <div className={contact.icon_container}>
                  <NavLink href='#' type='submit' name='Llamar GRATIS ' className={contact.button2} />
                  <p className={contact.title2}>Llámanos  </p>
                  <p className={contact.title3}>449 377 5591</p>
                </div>
              </div>
              <div className={contact.heimarg} />
            </div>
            <div className={contact.card_column}>
              <div className={contact.card}>
                <div className={contact.icon_container}>
                  <NavLink href='#' type='submit' name='Solicitar DEMO' className={contact.button2} />
                  <p className={contact.title2}>Solicita demostración</p>
                  <p className={contact.title3}>Asesoria Online</p>

                </div>
              </div>
              <div className={contact.volver}>
                <NavLink href='/help_center' type='submit' name='Volver' className={contact.button3} />
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}
